import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import './App.css';

import AuthState from "./context/authentication/authState";
import UsuariosState from "./context/usuarios/usuariosState";
import TenantsState from "./context/tenants/tenantsState";
import PlataformasState from "./context/plataformas/plataformasState";

import Login from "./views/login/Login";
import SharedLayout from "./components/SharedLayout";
import Tablero from "./views/tablero/Tablero";
import ABMs from "./views/abms/ABMs";
import Usuarios from "./views/usuarios/Usuarios";
import Tenants from "./views/tenants/Tenants";
import Plataformas from "./views/plataformas/Plataformas";

import RoutesConfig from "./utils/Routes";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthState>
                    <UsuariosState>
                        <TenantsState>
                            <PlataformasState>
                                <Routes>
                                    <Route path="/" element={<Login />} />
                                    <Route path="/login" element={<Login />} />
                                    <Route element={<SharedLayout />}>
                                        <Route path="/tablero" element={<Tablero />} />
                                        <Route path="/abms" element={<ABMs />} />
                                        <Route path="/abms/usuarios" element={<Usuarios />} />
                                        <Route path="/abms/tenants" element={<Tenants />} />
                                        <Route path="/abms/plataformas" element={<Plataformas />} />
                                    </Route>
                                    <Route path="*" element={<Navigate to="/" replace />} />
                                </Routes>
                            </PlataformasState>
                        </TenantsState>
                    </UsuariosState>
                </AuthState>
            </BrowserRouter>
        </div>
    );
}

export default App;
